import {List} from "immutable";
import * as React from 'react';
import {List as SemanticList} from 'semantic-ui-react';
import {BoardId} from "../../model/Board";
import {Node, sortNodesByType} from "../../model/Graph";
import {isValidLeaf} from "../BoardTreeView";
import BoardTreeLeaf from "./BoardTreeLeaf";
import BoardLayer from "./BoardLayer";

interface OwnProps {
    leafs: List<Node>;
    boardId: BoardId;
    expandLeafs: boolean;
    isMetadataVisible: boolean;
    layerId: string;
}

type BoardTreeProps = OwnProps;

const BoardTree = (props: BoardTreeProps) => {
    const leafs = props.leafs.filter(l => isValidLeaf(l, props.layerId))
        .sort(sortNodesByType)
        .map(ele => <BoardTreeLeaf layerId={props.layerId} expand={props.expandLeafs} element={ele} key={ele.getId()} boardId={props.boardId} isMetadataVisible={props.isMetadataVisible} />);

    return <SemanticList className="elements tree">{ leafs }</SemanticList>;
};

export default BoardTree;
